import React from 'react'
import ProductCard from '../ProductCard'
import fuji from '../../assets/fuji.jpeg'
import thermal from '../../assets/therm.png'
import ecg from '../../assets/ecg.webp'
import ecgpaper from '../../assets/ecg.jpeg'

    const data = [
        {
            id: 1,
            name: 'Fuji/Agfa Xray film',
            imgSrc: fuji,
        },
        {
            id: 2,
            name: 'ECG/EKG machine',
            imgSrc: ecg,
        },
        {
            id: 3,
            name: 'Thermal Paper',
            imgSrc: thermal,
        },
        {
            id: 4,
            name: 'ECG Paper',
            imgSrc: ecgpaper,
    },
    ]

export default function Card5() {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {data.map((item, index) => (
                <ProductCard key={item.id} product={item} index={index} />
            ))}
        </div>
    )
}
